<div class="container">
  <mic-breadcrumb id="casing-definition-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingDefinitionText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-definition-heading">{{ translationService.translate('casingDefinitionText') }}</h2>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="make"
          formControlName="make"
          [data]="makeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectMakeText') }}"
          label="{{ translationService.translate('makeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="series"
          formControlName="series"
          [data]="seriesList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectSeriesText') }}"
          label="{{ translationService.translate('seriesText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="size"
          formControlName="size"
          [data]="sizeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectSizeText') }}"
          label="{{ translationService.translate('sizeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <mic-spinner
    id="casing-definition-export-spinner"
    *ngIf="isExporting"
    ariaLabel="In Progress"
    color="primary"
    [strokeWidth]="5"
  ></mic-spinner>

  <div class="action-bar">
    <button id="reset-filters" class="btn-clear" type="button" mat-flat-button color="accent" (click)="clearFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>

    <button id="export-button-top" class="btn-primary" mat-flat-button color="primary" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <div id="casing-definition-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micTableColumnSelector>
        <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
          <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
        </button>
        <mat-menu #colMenu="matMenu">
          <div style="padding: 8px 16px; max-width: 320px">
            <div *ngFor="let key of columnKeys">
              <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                columnNames[key] || key
              }}</mat-checkbox>
            </div>
          </div>
        </mat-menu>
      </ng-container>
      <ng-container *micTableActions="let items"> </ng-container>
    </mic-table>
  </div>
</div>
